import qs from 'qs';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import MainButtonSet from '../../components/mainButtonSet';
import StageHeader from '../../components/stageHeader';
import UnisProductModal from '../../components/unisProductModal';
import tmsServiceBackend from '../../services/axios/tmsServiceBackend';
import template from './userProfile.vue';

@Component({
    mixins: [template],
    components: {
        StageHeader,
        MainButtonSet,
        UnisProductModal,
    },
})
export default class UserProfile extends Vue {
    userDetail: any = {};
    changePassword: any = {
        response_type: 1,
    };
    messageModalName: string = '';
    created() {
        this.getUserDetail();
    }

    mounted() {}

    getUserDetail() {
        this.userDetail = {};
        tmsServiceBackend.get('tms/client/user/detail').then(
            (res: any) => {
                if (res.status == 200) {
                    this.$set(this.userDetail, 'first_name', res.data.firstname);
                    this.$set(this.userDetail, 'last_name', res.data.lastname);
                    this.$set(this.userDetail, 'email', res.data.email);
                    this.$set(this.userDetail, 'phone', res.data.phone);
                    this.$set(this.userDetail, 'user_name', res.data.username);
                    this.$set(this.userDetail, 'role', res.data.role);
                    this.$set(this.userDetail, 'user_id', res.data.user_id);
                    this.$set(this.userDetail, 'is_ad_user', res.data.is_ad_user);
                }
            },
            (err: any) => {
                console.log(err);
            }
        );
    }

    onSubmit(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (res) {
                tmsServiceBackend
                    .post('tms/client/user/update', qs.stringify(this.userDetail))
                    .then(
                        (res: any) => {
                            this.showUpdated({
                                title: 'User info updated',
                                mag: 'User information updated successfully',
                            });
                        },
                        (err: any) => {
                            this.err('User info updated Error !');
                        }
                    );
            }
        });
    }

    onSubmitChangePassword(scope: any) {
        this.$validator.validateAll(scope).then(res => {
            if (this.errors && this.errors.items && this.errors.items.length > 0) {
                return false;
            }
            tmsServiceBackend
                .post('tms/client/user/password/update', qs.stringify(this.changePassword))
                .then(
                    (res: any) => {
                        this.changePassword = {
                            response_type: 1,
                        };
                        this.$modal.hide(this.messageModalName);

                        const data = res.data;
                        if (data.status < 0) {
                            this.err(data.message || 'Update Error !');
                            return;
                        }

                        this.showUpdated({
                            title: 'Password changed',
                            mag: 'Password changed successfully',
                        });
                    },
                    (error: any) => {
                        this.changePassword = {
                            response_type: 1,
                        };
                        this.err('Update Error !');
                    }
                );
        });
    }

    onChangePassword() {
        this.messageModalName = 'changePassword';
        this.$modal.show(this.messageModalName);
    }

    cancel() {
        this.$modal.hide(this.messageModalName);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./src/layouts/userProfile/index.ts